/**
 * FAQ section — category tabs + accordion-style question list.
 * All questions render server-side (one item + one answer panel per block);
 * this script filters by category and swaps the open question/answer pair.
 */
(function () {
  function initFaq(section) {
    if (section.dataset.faqInit === '1') return;
    section.dataset.faqInit = '1';

    var tabsBar = section.querySelector('[data-faq-tabs]');
    var list = section.querySelector('[data-faq-list]');
    var panel = section.querySelector('[data-faq-panel]');
    if (!tabsBar || !list || !panel) return;

    var tabs = Array.prototype.slice.call(tabsBar.querySelectorAll('.spi_faq-tab-btn'));
    var items = Array.prototype.slice.call(list.querySelectorAll('.spi_faq-item'));
    var answers = Array.prototype.slice.call(panel.querySelectorAll('.spi_faq-answer-inner'));

    function selectItem(id) {
      items.forEach(function (item) {
        var active = item.dataset.faqId === id;
        item.classList.toggle('spi_active', active);
        item.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      answers.forEach(function (answer) {
        answer.classList.toggle('spi_active', answer.dataset.faqId === id);
      });
    }

    function selectCategory(cat) {
      var firstId = null;
      items.forEach(function (item) {
        var match = item.dataset.category === cat;
        item.hidden = !match;
        if (match && firstId === null) firstId = item.dataset.faqId;
      });
      answers.forEach(function (answer) {
        answer.hidden = answer.dataset.category !== cat;
      });
      if (firstId !== null) selectItem(firstId);
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        selectItem(item.dataset.faqId);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.forEach(function (b) {
          b.classList.remove('spi_active');
        });
        btn.classList.add('spi_active');
        selectCategory(btn.dataset.category);
      });
    });

    var activeTab = tabsBar.querySelector('.spi_faq-tab-btn.spi_active') || tabs[0];
    if (activeTab) selectCategory(activeTab.dataset.category);
  }

  function initAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-faq-section]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
